import { generateSitemap } from "@/lib/singularity/other-singularity-file";
import { loadBuilderElementsFromWordPressWithPromise } from "@/lib/wordpress/load";
import { loadSingularitySectionLibrary } from "@/lib/singularity/page-generation";
import {
  getChatMessagesToRequestSectionPopulation,
  getTreeFromSectionDescriptions,
  populatePhantomSectionWithAiData
} from "./sections";
import { BatchRequest, BatchResponse, callAIBatch } from "./api/api";
import { Tree } from "@/types/tree";
import { PhantomPage, phantomPageHolder } from "./phantom-page-holder";
import { findNode, getBlankTree } from "@/lib/tree/tree";
import { getFieldsToComplete } from "@/lib/ai/ai";
import defensiveCopy from "@/util/defensive-copy";
import { cleanJson } from "@/lib/ai/api";

export async function generateSitemapPopulatePagesWithSectionsWriteContentAndUpdateImages() {
  phantomPageHolder.setPages(await getPagesWithTreesPopulatedFromLibrary());

  const batchRequestsForPages = phantomPageHolder.pages.map(
    getBatchRequestsForPage
  );

  const dataForAllPages = await Promise.all(
    batchRequestsForPages.map(async page => {
      return {
        pageTitle: page.title,
        data: await callAIBatch(
          page.requests /* (result: BatchResponse) => { console.log(`Response for ${result.id}:`, result.content); } */
        )
      };
    })
  );

  dataForAllPages.forEach(dataForPage => {
    updatePageFromBatchResponse(dataForPage.pageTitle, dataForPage.data);
  });

  console.log(phantomPageHolder.pages);
}

function updatePageFromBatchResponse(
  pageTitle: string,
  sectionRewriteResponses: BatchResponse[]
) {
  const page = phantomPageHolder.getPage(pageTitle);
  if (!page) return;

  const tree = defensiveCopy(page.tree);

  sectionRewriteResponses.forEach(sectionRewriteResponse => {
    const sectionToOperateOn = findNode(
      page.tree,
      Number(sectionRewriteResponse.id)
    );
    if (!sectionToOperateOn) return;
    populatePhantomSectionWithAiData(
      sectionToOperateOn,
      cleanJson(sectionRewriteResponse.content ?? ""),
      getFieldsToComplete(sectionToOperateOn),
      tree
    );
  });

  phantomPageHolder.updatePage(pageTitle, tree);
}

async function getPagesWithTreesPopulatedFromLibrary(): Promise<PhantomPage[]> {
  const sitemapPages = await generateSitemap();
  if (!sitemapPages) return [];

  // need to do this before we can use the tree
  await loadBuilderElementsFromWordPressWithPromise();

  // might be unnecessary as this might already be loaded
  await loadSingularitySectionLibrary();

  // TODO - run the all of the above in parallel

  const pagesWithTrees = sitemapPages.map(sitemapPage => {
    return {
      title: sitemapPage.title,
      tree: getTreeFromSectionDescriptions(sitemapPage.sections)
    };
  });

  return pagesWithTrees;
}

export function getBatchRequestsForPage(page: PhantomPage) {
  return {
    title: page.title,
    requests: page.tree.root.children.map(section => {
      return {
        id: String(section.id),
        messages: getChatMessagesToRequestSectionPopulation(section)
      };
    })
  };
}
